import { useContext } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import Brightness2Icon from '@mui/icons-material/Brightness2';
import { ThemeContext } from 'src/theme/ThemeProvider';

interface ToggleProps {
  currentTheme: string;
  onThemeChange: (theme: string) => void;
}

const Toggle = ({ currentTheme, onThemeChange }: ToggleProps) => {
  const setThemeName = useContext(ThemeContext);
  const isLight = currentTheme === 'PureLightTheme';

  const handleToggle = () => {
    const newTheme = isLight ? 'PureDarkTheme' : 'PureLightTheme';
    setThemeName(newTheme);
    onThemeChange(newTheme);
  };

  return (
    <Tooltip title={isLight ? 'Switch to dark mode' : 'Switch to light mode'}>
      <IconButton color="primary" onClick={handleToggle}>
        {isLight ? <Brightness7Icon /> : <Brightness2Icon />}
      </IconButton>
    </Tooltip>
  );
};

export default Toggle;
